/**
 * A named group inside an `order(...)` sequence, carrying the properties that belong to it.
 *
 * Membership is declared here rather than by an opening marker, so a sequence that interleaves
 * loose properties and groups has exactly one reading.
 */
export class IrdGroupEntry {
  private isCollapsible = false;
  private startsCollapsed = false;

  constructor(
    public readonly key: string,
    public readonly propertyKeys: readonly string[],
  ) {}

  /** The group can be folded away and starts folded. */
  public collapsed(): this {
    this.isCollapsible = true;
    this.startsCollapsed = true;
    return this;
  }

  /** The group can be folded away but starts open. */
  public collapsible(): this {
    this.isCollapsible = true;
    return this;
  }

  public get canCollapse(): boolean {
    return this.isCollapsible;
  }

  public get initiallyCollapsed(): boolean {
    return this.startsCollapsed;
  }
}

/**
 * Declares a named group and the properties in it.
 *
 * @example
 * .order('name', 'description', group('AUDIT', 'createdBy', 'createdAt').collapsed())
 */
export function group(key: string, ...propertyKeys: string[]): IrdGroupEntry {
  return new IrdGroupEntry(key, propertyKeys);
}

/** An entry in an `order(...)` sequence: either a property key or a named group. */
export type IrdOrderEntry = string | IrdGroupEntry;
